import { Component, NgZone, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, App, NavController, NavParams, Platform, Slides, ToastController, NavControllerBase, ModalController } from 'ionic-angular';
import { Subject, Subscription } from 'rxjs';
import { timer } from 'rxjs/observable/timer';
import { IconPipe } from '../../../pipes/icon/icon';
import { TwoNumPipe } from '../../../pipes/two-num/two-num';
import { ConfigProvider } from '../../../providers/config/config';
import { EventProvider, NearbyEventNew, RouteInfos } from '../../../providers/event/event';
import { GoogleMapsProvider } from '../../../providers/google-maps/google-maps';
import { LoaderProvider } from '../../../providers/loader/loader';
import { UserProvider } from '../../../providers/user/user';
import { ValueProvider } from '../../../providers/value/value';
import { MysportUserProfilePage } from '../../me/mysport/mysport-user-profile/mysport-user-profile';
import { NearbyModifyStartPage } from '../nearby-modify-start/nearby-modify-start';
import { SessionProvider } from '../../../providers/session/session';
import { LocationProvider } from '../../../providers/location/location';
import { NearbyMainViewModel } from './nearby-main-resolver';
import { NearbyEventParticipantSearchPage } from '../nearby-event-participant-search/nearby-event-participant-search';
import { LoginPage } from '../../login/login/login';
import { Storage } from '@ionic/storage';
import { IdRegistrationPage } from '../../login/id-registration/id-registration';
import { AppDetectorProvider } from '../../../providers/detector/detector';
import { EventRegistrationModel, StrackerProvider, TrackerModel } from '../../../providers/stracker/stracker';
import { GpsTracker } from '../../../tracker/gps-tracker';
import { GlobalUtil } from '../../../tracker/global-utils';
import { StrackerPage } from '../../../tracker/sencha-tracker/stracker';
import { StorageProvider } from '../../../providers/storage-service/storage-service';
import { HttpClient } from '@angular/common/http';
import { TrackingService, TrackingMode } from '../../../providers/tracking.service';
import L from 'leaflet';
import * as LO from 'leaflet.offline';
import { getTileUrls, getStorageInfo, truncate, downloadTile, saveTile } from 'leaflet.offline';
import { EventEmitter } from 'events';
import { PopupRegistrationComponent } from '../../../components/popup-registration/popup-registration';

declare var google;

@Component({
  selector: 'page-nearby-main',
  templateUrl: 'nearby-main.html'
})
export class NearbyMapPage {
  showMySport: boolean = false;
  reloadTrigger: boolean = true;
  nearbyEvents: NearbyEventNew[] = [];
  @ViewChild('dataSlider') dataSlider: Slides;

  activeItem: NearbyEventNew;
  baseLayer;
  urlTemplate = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

  dataReady: boolean = false
  mapReady: boolean = false;
  trackMyLocation: boolean = false;
  map: any;

  path: {
    fullPolyline: any;
    firstLastPoly: any;
    marker: {
      startMarker: any;
      endMarker: any;
      firstMarker: any;
      lastMarker: any;
      middleMarker: any;
      meMarker: any;
      participants: any[];
    };
  } = {
      fullPolyline: null,
      firstLastPoly: null,
      marker: {
        startMarker: null,
        endMarker: null,
        middleMarker: null,
        firstMarker: null,
        lastMarker: null,
        meMarker: null,
        participants: []
      }
    };

  texts: {
    countDown: string;
    middleDistance: string;
    firstDistance: string;
    lastDistance: string;
  } = {
      countDown: '',
      middleDistance: '-',
      firstDistance: '-',
      lastDistance: '-'
    };
  ghosts: { first: Ghost; middle: Ghost; last: Ghost } = {
    first: null,
    middle: null,
    last: null
  };

  removeSub = new Subject();
  firstLastLineAllowed: boolean = false;
  isGoogleMap: boolean = false;

  raceState: RaceState = RaceState.countdown;
  started: boolean = false;

  ghostSub: Subscription;

  viewModel: NearbyMainViewModel;
  participantFocusEnabled: boolean = true;

  buttonsNearby: boolean = false;
  buttonPlayStop: boolean = false;
  gpsOnSchedule: boolean = false;
  clientHannover: boolean = false;
  rowKmStatistics: boolean = false;

  play: boolean = false;

  SCHEDULE_GPS_OFF_TIME: number = 16; //off gps after 16:00:00
  SCHEDULE_GPS_CONTROL: boolean = false;

  token: string = "";

  // TEST 
  GPS_HIGH_ACCURACY: boolean = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private googleService: GoogleMapsProvider,
    public userService: UserProvider,
    public app: App,
    public translate: TranslateService,
    private loadingCtrl: LoaderProvider,
    private valueService: ValueProvider,
    private config: ConfigProvider,
    private eventService: EventProvider,
    private platform: Platform,
    private twoNum: TwoNumPipe,
    private icons: IconPipe,
    private sessionService: SessionProvider,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private storage: Storage,
    private detectorProvider: AppDetectorProvider,
    private strackerService: StrackerProvider,
    private storageService: StorageProvider,
    private httpClient: HttpClient,
    private appDetector: AppDetectorProvider,
    private geoService: TrackingService,
    private modalCtrl:ModalController
  ) {
    console.log('========================');
    this.viewModel = navParams.get('events');
    this.nearbyEvents = this.viewModel.nearbyEvents;
    this.trackMyLocation = this.viewModel.trackLocation;
    this.getConfigurable();
    if(!appDetector.isSpooortsApp()){
      this.onAuthSubscriptions();
    }
  }

  ionViewDidLoad() {
    if (!this.isGoogleMap) this.loaded(null);
    let doc = document.getElementsByClassName('leaflet-top');
    if (doc) {
      doc.item(0).setAttribute('style', "top: 12% !important");
      console.log('doc changed');
    }
  }

  async getConfigurable() {
    this.buttonsNearby = (await this.config.config).showHide.buttonsNearbyMain;
    this.buttonPlayStop = (await this.config.config).showHide.buttonPlayStop;
    // this.gpsOnSchedule = (await this.config.config).showHide.gpsOnSchedule;
    this.clientHannover = (await this.config.config).showHide.liveResults;
    this.rowKmStatistics = (await this.config.config).showHide.rowKmStatistics;
  }

  onAuthSubscriptions() {
    this.sessionService.getToken(false, false).then(token => this.token = token);
    this.sessionService.onRequestLoggedIn().subscribe(() => {
      this.sessionService.getToken(false, false).then(token => {
        this.token = token;
        console.log('[INFO: logged in updated token in geo service...]');
      });
    });

    this.removeSub.subscribe(() => {
      this.clearMarkerParticipants();
    })
    this.sessionService.onRequestLogout().subscribe(() => {
      this.activeItem.participants = [];
      this.activeItem.mode = null;
      this.geoService.stopPlugin();
      this.geoService.mode = TrackingMode.spectatorInvisible;
      this.bgPosSub = false;
      console.log('[INFO: logged out caused tracking termination...]');

      this.clearMarkerParticipants();
      if (this.nearbyEvents[0] != null) {
        GlobalUtil.getInstance().currentEventID = this.nearbyEvents[0].id;
      }
      this.reload();
    });
  }

  openModify() {
    console.log('openModify()');
    new Promise((resolve, reject) => {
      (this.app.getRootNav() as NavController).push(NearbyModifyStartPage, {
        active: this.activeItem, resolve: resolve
      });
    }).then(status => {
      if (status)
        this.ngAfterViewInit();
    });
  }

  ngAfterViewInit() {
    console.log('ngAfterViewInit()');
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loading.present();
    setTimeout(async () => {
      this.showMySport = (await this.config.config).showHide.mysport;

      this.dataSlider.slideTo(this.viewModel.selectedIndex, 0);

      this.ionSlideDidChange().then(() => {
        this.dataReady = true;
        this.tryInit().then(() => {
          this.renderParticipants();
        });
      });
      loading.dismiss();
    }, 300);
  }

  onResultsRedirect() {
    this.navCtrl.popToRoot();
    if (this.clientHannover) this.app.getRootNav().getActiveChildNav().select(2);
    else this.app.getRootNav().getActiveChildNav().select(1);
  }

  onPlayToogle() {
    this.play = !this.play;

    this.toastCtrl.create({
      message: (this.play) ? this.translate.instant('ON_TRACKING_ENABLE') : this.translate.instant('ON_TRACKING_DISABLE'),
      duration: 5000,
      position: 'top'
    }).present();

    if (this.play) {
      this.trackMyLocation = true;
      this.activeItem.mode = 'participate';
      this.geoService.mode = TrackingMode.participant;
      this.onLocation();
    } else {
      this.trackMyLocation = false;
      this.activeItem.mode = 'spectate_simple';
      this.geoService.mode = TrackingMode.spectatorInvisible;
    }

    this.updateMap();
  }

  updateMap() {
    this.updateScheduling();
    this.meMarkerMoveUpdate();
    this.ngAfterViewInit();
    this.focusMap();
  }

  focusMap() {
    if (this.play && this.trackMyLocation && !this.SCHEDULE_GPS_CONTROL) this.focusOnCurrentPosition();
    else this.focusOnRoute();
  }

  updateScheduling() {
    if (this.SCHEDULE_GPS_CONTROL) this.stopScheduling();
  }

  meMarkerMoveUpdate() {
    if (!this.play) {
      const elem = this.path.marker.meMarker;
      if (elem) {
        if (this.isGoogleMap) {
          elem.setMap(null);
        } else {
          // DONE: leaflet
          this.map.removeLayer(elem);
        }
      }
      delete this.path.marker.meMarker;
      this.path.marker.meMarker = null;
      console.log('me marker removed...');
    }
  }


  ionSlideDidChange(): Promise<any> {
    console.log('ionSlideDidChange()');
    return new Promise(resolve => {
      if (this.nearbyEvents.length > (this.dataSlider.getActiveIndex() || 0)) {
        this.activeItem = this.nearbyEvents[this.dataSlider.getActiveIndex() || 0];
        this.viewModel.selectedIndex = this.dataSlider.getActiveIndex();

        if (this.bgPosSub) {
          this.geoService.stopPlugin();
          this.bgPosSub = false;
        }
        this.startSendingPosition();
        this.tryInit().then(() => {
          this.updateTime().then(() => {
            this.texts.firstDistance = '-';
            this.texts.lastDistance = '-';
            this.texts.middleDistance = '-';
            this.start().then(() => {
              resolve(null);
            });
          });
        });
      } else {
        resolve(null);
      }
    });
  }

  tryInit(): Promise<any> {
    console.log('tryInit()');
    return new Promise((resolve, reject) => {
      if (this.dataReady && this.mapReady) {
        this.initMap().then(() => resolve(null));
      } else {
        resolve(null);
      }
    });
  }

  clear() {
    this.isGoogleMap ? this.clearGoogle() : this.clearLeaflet();
  }

  clearGoogle() {
    if (this.path.fullPolyline) {
      this.path.fullPolyline.setMap(null);
      delete this.path.fullPolyline;
    }

    if (this.path.marker.startMarker !== null) {
      this.path.marker.startMarker.setMap(null);
      delete this.path.marker.startMarker;
      this.path.marker.startMarker = null;
      if (this.path.marker.endMarker !== null) {
        this.path.marker.endMarker.setMap(null);
        delete this.path.marker.endMarker;
        this.path.marker.endMarker = null;
      }
    }
    this.clearMarkerParticipants();
  }
  clearLeaflet() {
    // DONE: leaflet
    if (this.path.fullPolyline) {
      console.log('line removed!');
      this.map.removeLayer(this.path.fullPolyline);
      delete this.path.fullPolyline;
    }

    if (this.path.marker.startMarker !== null) {
      this.map.removeLayer(this.path.marker.startMarker);
      delete this.path.marker.startMarker;
      this.path.marker.startMarker = null;
      if (this.path.marker.endMarker !== null) {
        this.map.removeLayer(this.path.marker.endMarker);
        delete this.path.marker.endMarker;
        this.path.marker.endMarker = null;
      }
    }
    this.clearMarkerParticipants();
  }

  timer: Subscription;
  positionSub: Subscription;
  bgPosSub: boolean = false;
  participantSub: Subscription;
  scheduleGPS: Subscription;

  ionViewWillEnter() {
    if (!this.timer) {
      this.timer = timer(0, 990).subscribe(() => {
        this.updateTime();
      });
    }
    if (!this.ghostSub) {
      this.start();
    }

    this.startScheduling();

    if (!this.participantSub) {
      this.participantSub = timer(0, 2000).subscribe(() => {
        console.log('subscription 2000 sec to render')
        this.renderParticipants();
      });
    }
    if (!this.bgPosSub && this.activeItem && this.activeItem.mode === 'participate') {
      this.startSendingPosition();
    }
  }

  initMode() {
    console.log('initMode')
    if (this.activeItem === undefined) {
      console.log('in initmode')
      if (this.nearbyEvents.length > (this.dataSlider.getActiveIndex() || 0)) {
        this.activeItem = this.nearbyEvents[this.dataSlider.getActiveIndex() || 0];
        this.viewModel.selectedIndex = this.dataSlider.getActiveIndex();
      } else {
        return;
      }
    }

    this.activeItem.participants = JSON.parse(localStorage.getItem('participants')) || [];
  }

  startScheduling() {
    if (!this.scheduleGPS)
      this.scheduleGPS = timer(0, 1000).subscribe(() => {
        this.updateTracking();
      });
  }

  stopScheduling() {
    if (this.scheduleGPS) {
      this.SCHEDULE_GPS_CONTROL = false;
      this.scheduleGPS.unsubscribe();
      this.scheduleGPS = null;
    }
  }

  updateTracking() {
    if (this.gpsOnSchedule) {

      if (new Date().getUTCHours() > this.SCHEDULE_GPS_OFF_TIME && this.isEventDay()) {
        this.SCHEDULE_GPS_CONTROL = true;
        if (this.play && this.trackMyLocation) {
          this.play = false;
          this.trackMyLocation = false;
          this.clearMarkerParticipants();
          this.tryInit().then(() => this.renderParticipants());
          this.stopScheduling();
          console.log('[INFO] stopped scheduling');
        }
      }
    }
  }

  isEventDay(): boolean {
    let time = new Date().getTime();
    return (this.activeItem.date - time > 0) ? false : true;
  }

  getMode(i: number) {
    return (this.nearbyEvents[i].mode === null) ? true : false;
  }

  getRandomInRange(from, to, fixed) {
    console.log('getRandomInRange()');
    return (Math.random() * (to - from) + from).toFixed(fixed) * 1;
    // .toFixed() returns string, so ' * 1' is a trick to convert to number
  }

  changeTrackingStatus() {
    console.log('changeTrackingStatus()');
    this.trackMyLocation = !this.trackMyLocation;
    this.focusOnCurrentPosition();
  }

  focusOnCurrentPosition() {
    this.isGoogleMap ? this.focusOnCurrentPositionGoogle() : this.focusOnCurrentPositionLeaflet();
  }

  focusOnCurrentPositionGoogle() {
    if (this.play && this.trackMyLocation && this.path.marker.meMarker) {
      let pos = this.path.marker.meMarker.getPosition();
      if (pos) {
        this.map.panTo(pos);
      }
    }
  }
  focusOnCurrentPositionLeaflet() {
    // DONE: leaflet
    if (this.play && this.trackMyLocation && this.path.marker.meMarker) {
      let pos = this.path.marker.meMarker.getLatLng();
      if (pos) {
        this.map.flyTo(pos);
      }
    }
  }

  focusOnRoute() {
    this.isGoogleMap ? this.focusOnRouteGoogle() : this.focusOnRouteLeaflet();
  }
  focusOnRouteGoogle() {
    if (this.path.marker.startMarker)
      this.map.panTo(this.path.marker.startMarker);
  }
  focusOnRouteLeaflet() {
    // DONE: leaflet
    if (this.path.marker.startMarker) {
      let pos = this.path.marker.startMarker.getLatLng();
      this.map.flyTo(pos);
    }
  }

  startSendingPosition() {
    console.log('startSendingPosition()');
    if (!this.play && !this.trackMyLocation) {
      console.log('return;')
      return;
    }
    if (this.activeItem.mode !== null) {
      console.log('setupPlugin()');
      this.geoService.setupPlugin().then(() => {
        console.log('[INFO: The plugin has set up...]');
      });
    }
  }

  onLocation() {
    console.log('onLocation: ');
    if (this.bgPosSub) return;

    this.geoService.onRequestLocation().subscribe((location) => {
      this.coords.push({ lat: location.coords.latitude, lng: location.coords.longitude });
      localStorage.setItem('last-pos', JSON.stringify({ lat: location.coords.latitude, lng: location.coords.longitude }));
      this.saveTiles();
      console.log('[INFO] onLocation()...');
      this.meMarkerMove({
        coords: location.coords,
        timestamp: 12312
      });
      this.bgPosSub = true;
    });
  }

  coords = [];
  saveTiles() {
    let points = this.coords.map(coords => L.point(coords.lat, coords.lng));
    console.log('points: ', points);
    let bounds = L.bounds(points);
    let urls = getTileUrls(this.baseLayer, bounds, 16);
    console.log('urls: ', urls);
    for (let i = 0; i < urls.length; i++) {
      downloadTile(urls[i].url).then(blob => {
        console.log('blob: ', blob);
        saveTile(urls[i], blob).then(() => {
          console.log('tile saved: ' + urls[i].url);
        });
      });
    }
  }

  onHttp(response) {
    console.log("[http] response: ", response.success, response.status, response.responseText);
  }

  testCounterTemp: number = new Date().getTime();
  updateTime(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (this.activeItem) {
        let time = this.activeItem.date - new Date().getTime();
        // if (this.raceState === RaceState.finished) {
        //   this.texts.countDown = this.translate.instant('NEARBY_END');
        // } else {
        this.texts.countDown = this.timeFormat(time) + '';
        // }

        if (this.dataReady && this.mapReady) {
          if (this.activeItem.timeInfos && this.activeItem.timeInfos.length < 1) {
            return;
          }
          if (this.activeItem.timeInfos && this.activeItem.timeInfos[this.activeItem.timeInfos.length - 1].time * 1000 + time < 0) {

            this.raceState = RaceState.started;
            this.start().then(() => {
              this.raceState = RaceState.finished;
              this.stop();
            });
          } else if (this.raceState === RaceState.countdown && time < 0) {
            // } else if (this.raceState === RaceState.countdown && time < 0 && this.activeItem.mode !== null)  probable bug
            this.raceState = RaceState.started;
            this.start().then(() => {
              resolve(null);
            });
          } else if (this.raceState === RaceState.started && time > 0) {
            this.stop();

            this.raceState = RaceState.countdown;
            resolve(null);
          } else {
            resolve(null);
          }
        } else {
          resolve(null);
        }
      } else {
        resolve(null);
      }
      // if (this.path.marker.startMarker && this.activeItem.fullPath.length > 2) {
      // this.path.marker.startMarker.setVisible(this.raceState !== RaceState.started);
      // }
    });
  }

  clearMarkerParticipants() {
    this.isGoogleMap ? this.clearMarkerParticipantsGoogle() : this.clearMarkerParticipantsLeaflet();
  }
  clearMarkerParticipantsGoogle() {
    if (this.path.marker.participants.length > 0) {
      for (let i = this.path.marker.participants.length - 1; i > -1; i--) {
        const element = this.path.marker.participants[i];
        element.setMap(null);
        delete this.path.marker.participants[i];
      }
      this.path.marker.participants = [];
    }
  }
  clearMarkerParticipantsLeaflet() {
    // DONE: leaflet
    console.log('clearMarkerParticipantsLeaflet()');
    console.log('this.path.marker.participants.length: ' + this.path.marker.participants.length);
    if (this.path.marker.participants.length > 0) {
      for (let i = this.path.marker.participants.length - 1; i > -1; i--) {
        const element = this.path.marker.participants[i];
        this.map.removeLayer(element);
        delete this.path.marker.participants[i];
      }
      this.path.marker.participants = [];
    }
  }

  renderParticipants() {
    if (this.mapReady && this.dataReady && !this.SCHEDULE_GPS_CONTROL) {
      this.isGoogleMap ? this.renderGoogle() : this.renderLeaflet();
    }
  }
  renderGoogle() {

    this.googleService.getGoogle().then(google => {
      let ids = [];
      this.activeItem.participants.forEach(item => {
        ids.push(item.lid);
      });
      console.log('this.activeItem.participants: ', JSON.stringify(this.activeItem.participants));
      this.eventService.getNearbyParticipantPosititons(ids, this.activeItem.id).then(async response => {
        this.clearMarkerParticipants();
        let participants = this.activeItem.participants;
        if (this.sessionService.isLoged) {
          this.userService.getPrivateProfile().then(profile => {
            let name = (profile.forName + profile.surName).toUpperCase();
            let filtered = (this.activeItem.mode === 'spectate_simple') ? response.filter(r => name != this.getNameById(r.lid)) : response;
            for (let i = 0; i < filtered.length; i++) {
              this.path.marker.participants.push(
                new google.maps.Marker({
                  map: this.map
                })
              );
              const element = filtered[i];
              const participant = participants.find(x => x.lid === parseInt(element.lid + ''));
              this.path.marker.participants[i].setPosition(new google.maps.LatLng(element.lat, element.lng));
              this.path.marker.participants[i].setTitle(element.lid);
              this.path.marker.participants[i].setIcon(participant.img);
            }
          });
        }
      });
    });
  }
  renderLeaflet() {
    console.log('renderLeaflet()');
    if (this.activeItem.participants.length == 0) this.activeItem.participants = JSON.parse(localStorage.getItem('participants')) || [];
    let ids = [];
    this.activeItem.participants.forEach(item => {
      ids.push(item.lid);
    });
    console.log('this.activeItem.participants.length: ' + this.activeItem.participants.length);
    this.eventService.getNearbyParticipantPosititons(ids, this.activeItem.id).then(async response => {
      console.log('response: ', response);
      let participants = this.activeItem.participants;
      if (this.sessionService.isLoged) {
        this.userService.getPrivateProfile().then(profile => {
          let name = (profile.forName + profile.surName).toUpperCase();
          let filtered = (this.activeItem.mode === 'spectate_simple') ? response.filter(r => name != this.getNameById(r.lid)) : response;
          for (let i = 0; i < filtered.length; i++) {
            const element = filtered[i];
            const actParticipant = this.path.marker.participants.findIndex((p) => p.uniId == element.lid + '');
            if (actParticipant > -1) {
              this.path.marker.participants[actParticipant].setLatLng(L.latLng(element.lat, element.lng));

              // Focus on the first followed participant
              if (i == 0 && this.participantFocusEnabled) this.map.setView(L.latLng(element.lat, element.lng));
            } else {
              let list = this.path.marker.participants;
              this.path.marker.participants.push(
                new L.Marker([0, 0])
              );
              this.path.marker.participants[list.length - 1].uniId = element.lid + '';
              const participant = participants.find(x => x.lid === parseInt(element.lid + ''));
              this.path.marker.participants[list.length - 1].setLatLng(L.latLng(element.lat, element.lng));
              // this.path.marker.participants[i].setTitle(element.id);
              let myIcon = L.icon({
                iconUrl: participant.img,
                iconSize: [35, 35]
              });
              this.path.marker.participants[i].setIcon(myIcon);

              this.path.marker.participants[i].addTo(this.map);
              console.log('this.path.marker.participants: ', this.path.marker.participants);
            }
          }
        });
      }
    });
  }

  getNameById(id): string {
    let p = this.activeItem.participants;
    for (let i = 0; i < p.length; i++) {
      if (id == p[i].lid)
        return (p[i].firstName + p[i].lastName).toUpperCase();
    }
    return "";
  }

  start(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isGoogleMap ? this.startGoogle(resolve) : this.startLeaflet(resolve);
    });
  }

  startGoogle(resolve: any) {
    this.googleService.getGoogle().then(async google => {
      if (this.dataReady && this.mapReady && this.raceState !== RaceState.countdown) {
        if (!this.ghosts.first) {
          this.path.firstLastPoly = new google.maps.Polyline({
            geodesic: true,
            strokeColor: '#ff3c07',
            strokeOpacity: 1.0,
            strokeWeight: 5,
            map: this.map,
            zIndex: 4
          });

          this.path.marker.firstMarker = new google.maps.Marker({
            map: this.map,
            icon: this.icons.get('marker', 'first'),
            visibility: false
          });

          this.path.marker.lastMarker = new google.maps.Marker({
            map: this.map,
            icon: this.icons.get('marker', 'last'),
            visibility: false
          });

          let firstTime = this.activeItem.timeInfos.length > 0 ? this.activeItem.timeInfos[0].time : null;
          let lastTime = this.activeItem.timeInfos.length > 1 ? this.activeItem.timeInfos[this.activeItem.timeInfos.length - 1].time : null;

          let middleTime = this.activeItem.timeInfos.length > 2 ? this.activeItem.timeInfos[1].time : null;

          this.ghosts.first = new Ghost(this.activeItem.fullPath, google, this.activeItem.date, firstTime);
          this.ghosts.last = new Ghost(this.activeItem.fullPath, google, this.activeItem.date, lastTime);
          this.ghosts.middle = new Ghost(this.activeItem.fullPath, google, this.activeItem.date, middleTime);
          this.ghosts.last.other = this.ghosts.first;
          this.ghosts.first.other = this.ghosts.last;
        } else {
          let firstTime = this.activeItem.timeInfos.length > 0 ? this.activeItem.timeInfos[0].time : null;
          let lastTime = this.activeItem.timeInfos.length > 1 ? this.activeItem.timeInfos[this.activeItem.timeInfos.length - 1].time : null;
          let middleTime = this.activeItem.timeInfos.length > 2 ? this.activeItem.timeInfos[1].time : null;

          this.ghosts.first.update(this.activeItem.fullPath, this.activeItem.date, firstTime);
          this.ghosts.last.update(this.activeItem.fullPath, this.activeItem.date, lastTime);
          this.ghosts.middle.update(this.activeItem.fullPath, this.activeItem.date, middleTime);

          this.updateGhosts();
        }
        if (!this.ghostSub) {
          this.ghostSub = timer(0, 3000).subscribe(() => {
            this.updateGhosts();
          });
        }

        resolve(null);
      } else {
        resolve(null);
      }
    });
  }
  startLeaflet(resolve: any) {
    // DONE: leaflet
    this.googleService.getGoogle().then(async google => {

      if (this.dataReady && this.mapReady && this.raceState !== RaceState.countdown) {
        if (!this.ghosts.first) {
          this.path.firstLastPoly = L.polyline([], {
            color: '#ff3c07',
          });
          this.path.firstLastPoly.addTo(this.map);

          let firstMarkerIcon = new L.Icon({
            iconUrl: this.icons.get('marker', 'first'),
            iconSize: [32, 32],
            iconAnchor: [16, 16],
          });
          this.path.marker.firstMarker = new L.Marker([0, 0], {
            icon: firstMarkerIcon
          });
          this.path.marker.firstMarker.addTo(this.map);

          let lastMarkerIcon = new L.Icon({
            iconUrl: this.icons.get('marker', 'last'),
            iconSize: [32, 32],
            iconAnchor: [16, 16],
          });
          this.path.marker.lastMarker = new L.Marker([0, 0], {
            icon: lastMarkerIcon
          });
          this.path.marker.lastMarker.addTo(this.map);

          let firstTime = this.activeItem.timeInfos.length > 0 ? this.activeItem.timeInfos[0].time : null;
          let lastTime = this.activeItem.timeInfos.length > 1 ? this.activeItem.timeInfos[this.activeItem.timeInfos.length - 1].time : null;

          let middleTime = this.activeItem.timeInfos.length > 2 ? this.activeItem.timeInfos[1].time : null;

          this.ghosts.first = new Ghost(this.activeItem.fullPath, google, this.activeItem.date, firstTime);
          this.ghosts.last = new Ghost(this.activeItem.fullPath, google, this.activeItem.date, lastTime);
          this.ghosts.middle = new Ghost(this.activeItem.fullPath, google, this.activeItem.date, middleTime);
          this.ghosts.last.other = this.ghosts.first;
          this.ghosts.first.other = this.ghosts.last;
        } else {
          let firstTime = this.activeItem.timeInfos.length > 0 ? this.activeItem.timeInfos[0].time : null;
          let lastTime = this.activeItem.timeInfos.length > 1 ? this.activeItem.timeInfos[this.activeItem.timeInfos.length - 1].time : null;
          let middleTime = this.activeItem.timeInfos.length > 2 ? this.activeItem.timeInfos[1].time : null;

          this.ghosts.first.update(this.activeItem.fullPath, this.activeItem.date, firstTime);
          this.ghosts.last.update(this.activeItem.fullPath, this.activeItem.date, lastTime);
          this.ghosts.middle.update(this.activeItem.fullPath, this.activeItem.date, middleTime);

          this.updateGhosts();
        }
        if (!this.ghostSub) {
          this.ghostSub = timer(0, 3000).subscribe(() => {
            this.updateGhosts();
          });
        }

        resolve(null);
      } else {
        resolve(null);
      }
    });
  }

  updateGhosts() {
    this.isGoogleMap ? this.updateGhostsGoogle() : this.updateGhostsLeaflet();
  }
  updateGhostsGoogle() {
    if (this.ghosts.first && this.ghosts.last) {
      Promise.all([this.ghosts.first.getPos(), this.ghosts.last.getPos()]).then(pos => {
        if (pos[0]) {
          this.texts.firstDistance = this.ghosts.first.getDistanceFromStartInKm();
        }
        if (pos[1]) {
          this.texts.lastDistance = this.ghosts.last.getDistanceFromStartInKm();
        }
        if (this.raceState === RaceState.started) {
          this.ghosts.first.getWayToOther().then(path => {
            //this.path.marker.firstMarker.setPosition(pos[0]);
            //this.path.marker.lastMarker.setPosition(pos[1]);
            if (this.firstLastLineAllowed) {
              if (this.isGoogleMap) {
                this.path.firstLastPoly.setPath(path);
                this.path.firstLastPoly.setVisible(true);
              } else {
                // DONE: leaflet
                this.path.firstLastPoly.setLatLng(path);
                this.path.firstLastPoly.addTo(this.map);
              }
            }
          });
        } else {
          if (this.firstLastLineAllowed) {
            if (this.isGoogleMap) {
              this.path.firstLastPoly.setVisible(false);
            } else {
              // DONE: leaflet
              this.path.firstLastPoly.remove(this.map);
            }
          }
        }
      });
    }
    if (this.ghosts.middle && this.raceState === RaceState.started) {
      this.ghosts.middle.getPos().then(pos => {
        this.texts.middleDistance = this.ghosts.middle.getDistanceFromStartInKm();
      });
    }
  }
  updateGhostsLeaflet() {
    // DONE: leaflet
    if (this.ghosts.first && this.ghosts.last) {
      Promise.all([this.ghosts.first.getPos(), this.ghosts.last.getPos()]).then(pos => {
        if (pos[0]) {
          this.texts.firstDistance = this.ghosts.first.getDistanceFromStartInKm();
        }
        if (pos[1]) {
          this.texts.lastDistance = this.ghosts.last.getDistanceFromStartInKm();
        }
        if (this.raceState === RaceState.started) {
          this.ghosts.first.getWayToOther().then(path => {
            //this.path.marker.firstMarker.setPosition(pos[0]);
            //this.path.marker.lastMarker.setPosition(pos[1]);
            if (this.firstLastLineAllowed) {
              if (this.isGoogleMap) {
                this.path.firstLastPoly.setPath(path);
                this.path.firstLastPoly.setVisible(true);
              } else {
                // Done: leaflet
                this.path.firstLastPoly.setLatLngs(path);
                this.path.firstLastPoly.addTo(this.map);
              }
            }
          });
        } else {
          if (this.firstLastLineAllowed) {
            if (this.isGoogleMap) {
              this.path.firstLastPoly.setVisible(false);
            } else {
              // DONE: leaflet
              this.path.firstLastPoly.remove(this.map)
            }
          }
        }
      });
    }
    if (this.ghosts.middle && this.raceState === RaceState.started) {
      this.ghosts.middle.getPos().then(pos => {
        this.texts.middleDistance = this.ghosts.middle.getDistanceFromStartInKm();
      });
    }
  }

  stop() {
    console.log('[INFO] stop()...');
    if (this.ghostSub) {
      this.ghostSub.unsubscribe();
      this.ghostSub = null;
    }

    this.updateGhosts();
  }

  timeFormat(time): string {
    console.log('timeFormat()');
    let year = 30758400000;
    let day = 86400000;
    time = Math.abs(time);

    if (Math.abs(time) > year) {
      let yearV = Math.floor(time / year);
      let dayV = Math.floor((yearV * year - time) / day);

      return this.translate.instant('GLOBAL_X_YEARS', {
        count: String(Math.abs(yearV))
      });
    } else if (Math.abs(time) > day) {
      let dayV = Math.floor(time / day);
      let hourV = Math.floor((dayV * day - time) / 3600000);

      return this.translate.instant('GLOBAL_X_DAYS', {
        count: String(Math.abs(dayV))
      });
    } else if (Math.abs(time) < day) {
      return (
        this.twoNum.transform('' + Math.floor((time % 86400000) / 3600000)) +
        ':' +
        this.twoNum.transform('' + Math.floor((time % 3600000) / 60000)) +
        ':' +
        this.twoNum.transform('' + Math.floor((time % 60000) / 1000))
      );
    }
  }

  ionViewWillLeave() {
    let keyName = this.sessionService.profile ? this.sessionService.profile.forName + this.sessionService.profile.surName : "default";
    this.storage.set('participants' + keyName, this.activeItem.participants).then(() => {
      console.log(`[Set participants(${this.activeItem.participants.length}) for ${keyName}`);
    });

    if (this.comingToParticipantListPage) { this.comingToParticipantListPage = false; return; }

    this.viewModel.mapState = {
      center: this.map.getCenter(),
      zoom: this.map.getZoom()
    };
    this.viewModel.trackLocation = this.trackMyLocation;
    if (this.timer) {
      this.timer.unsubscribe();
      this.timer = null;
    }
    if (this.ghostSub) {
      this.ghostSub.unsubscribe();
      this.ghostSub = null;
    }

    if (this.positionSub) {
      this.positionSub.unsubscribe();
      this.positionSub = null;
    }

    if (this.participantSub) {
      this.participantSub.unsubscribe();
      this.participantSub = null;
    }
    if (this.bgPosSub) {
      this.geoService.stopPlugin();
      this.bgPosSub = false;
    }

    if (this.saveTilesSub) {
      this.saveTilesSub.unsubscribe();
      this.saveTilesSub = null;
    }
    this.stopScheduling();
  }

  initMap(): Promise<any> {
    console.log('initMap()');
    return new Promise((resolve, reject) => {
      this.isGoogleMap ? this.initMapGoogle(resolve) : this.initMapLeaflet(resolve);
    });
  }
  initMapGoogle(resolve: any) {
    this.clear();
    this.raceState = RaceState.countdown;
    this.platform.ready().then(() => {
      this.googleService.getGoogle().then(async google => {
        if (this.activeItem) {
          if (!this.activeItem.routeInfos) {
            this.activeItem.routeInfos = [];
            this.activeItem.fullPath = [];

            for (let index = 0; index < this.activeItem.evtInfosList.length; index++) {
              const item = this.activeItem.evtInfosList[index];
              if (item.routeData.length > 0) {
                let routeInfos = JSON.parse(this.activeItem.routeData) as RouteInfos;
                this.activeItem.routeInfos.push(routeInfos);
                routeInfos.routeInfos.forEach(info => {
                  this.activeItem.fullPath = this.activeItem.fullPath.concat(google.maps.geometry.encoding.decodePath(info.path));
                });
              } else {
                if (this.activeItem.event.lat !== null && this.activeItem.event.lng !== null) {
                  this.activeItem.fullPath = [new google.maps.LatLng(this.activeItem.event.lat, this.activeItem.event.lng)];
                } else {
                  let pos = await new Promise<any>(possolve => {
                    let geocoder = new google.maps.Geocoder();

                    geocoder.geocode(
                      {
                        address: this.activeItem.event.plz + ' ' + this.activeItem.event.place
                      },
                      (results, status) => {
                        if (status == google.maps.GeocoderStatus.OK) {
                          let result;
                          if (results.length > 1) {
                            result = results[1];
                          } else {
                            result = results[0];
                          }
                          possolve(result);
                          //me.searchModel.zip = result.address_components[4].long_name;
                        } else {
                          possolve(null);
                        }
                      }
                    );
                  });
                  if (pos !== null) {
                    this.activeItem.fullPath = [pos.geometry.location];
                  }
                }
              }
            }
          }

          var styledMapType = new google.maps.StyledMapType(
            [
              {
                featureType: 'landscape',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off'
                  }
                ]
              },
              {
                featureType: 'transit',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off'
                  }
                ]
              },
              {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off'
                  }
                ]
              },
              {
                featureType: 'water',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off'
                  }
                ]
              },
              {
                featureType: 'road',
                elementType: 'labels.icon',
                stylers: [
                  {
                    visibility: 'off'
                  }
                ]
              },
              {
                stylers: [
                  {
                    hue: '#00aaff'
                  },
                  {
                    saturation: -100
                  },
                  {
                    gamma: 2.15
                  },
                  {
                    lightness: 12
                  }
                ]
              },
              {
                featureType: 'road',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    visibility: 'on'
                  },
                  {
                    lightness: 24
                  }
                ]
              },
              {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [
                  {
                    lightness: 57
                  }
                ]
              }
            ],
            { name: 'Spooorts minimal' }
          );
          this.path.fullPolyline = new google.maps.Polyline({
            path: this.activeItem.fullPath,
            geodesic: true,
            strokeColor: "#009ad0", // (await this.config.config).theme.color,
            strokeOpacity: 1.0,
            strokeWeight: 2,
            map: this.map
          });
          if (!this.viewModel.mapState) {
            let bounds = new google.maps.LatLngBounds();
            this.activeItem.fullPath.forEach(item => {
              bounds.extend(item);
            });
            //corrigate
            let ne = bounds.getNorthEast();
            let sw = bounds.getSouthWest();

            let center = {
              lat: ne.lat() - (ne.lat() - sw.lat()) * (this.platform.height() / (this.platform.height() - 280) / 2),
              lng: ne.lng() - (ne.lng() - sw.lng()) / 2
            };

            let nb: {
              ne: { lat: number; lng: number };
              sw: { lat: number; lng: number };
            } = {
              ne: {
                lat: ne.lat() + (ne.lat() - sw.lat()) * (this.platform.height() / (this.platform.height() - 280) / 4),
                lng: ne.lng()
              },
              sw: {
                lat: sw.lat(),
                lng: sw.lng()
              }
            };
            let zoom = this.getBoundsZoomLevel(nb);

            this.map.setCenter(center);
            this.map.setZoom(zoom);
          } else {
            this.map.setCenter(this.viewModel.mapState.center);
            this.map.setZoom(this.viewModel.mapState.zoom);
          }

          if (this.activeItem.fullPath.length > 0) {
            console.log('this.activeItem.event.cid: ' + this.activeItem.event.cid);
            this.path.marker.startMarker = new google.maps.Marker({
              position: this.activeItem.fullPath[0],
              map: this.map,
              icon: await this.icons.transform(this.activeItem.event.cid + '', 'marker')
            });
            if (this.activeItem.fullPath.length > 1) {
              this.path.marker.endMarker = new google.maps.Marker({
                position: this.activeItem.fullPath[this.activeItem.fullPath.length - 1],
                map: this.map,
                icon: this.icons.get('marker', 'finish')
              });
            }
          }
          this.map.mapTypes.set('spooorts_minimal', styledMapType);
          this.map.setMapTypeId('spooorts_minimal');
        } else {
        }
        resolve(null);
      });
    });
  } 
  initMapLeaflet(resolve: any) {
    if(this.appDetector.isForestApp()){
      this.initMapLeafletGoforest(resolve);
      return;
    }
    // DONE: leaflet
    this.clear();
    this.raceState = RaceState.countdown;
    this.platform.ready().then(() => {
      this.googleService.getGoogle().then(async google => {
        if (this.activeItem) {
          if (!this.activeItem.routeInfos) {
            this.activeItem.routeInfos = [];
            this.activeItem.fullPath = [];

              if (this.activeItem.routeData.length > 0) {
                let routeInfos = JSON.parse(this.activeItem.routeData) as RouteInfos;
                this.activeItem.routeInfos.push(routeInfos);
                routeInfos.routeInfos.forEach(info => {
                  this.activeItem.fullPath = this.activeItem.fullPath.concat(google.maps.geometry.encoding.decodePath(info.path));
                });
              } else {
                if (this.activeItem.lat !== null && this.activeItem.lng !== null) {
                  this.activeItem.fullPath = [new L.LatLng(this.activeItem.lat, this.activeItem.lng)];
                } else {
                  let pos = await new Promise<any>(possolve => {
                    let geocoder = new google.maps.Geocoder();

                    geocoder.geocode(
                      {
                        address: `${this.activeItem.plz}, ${this.activeItem.place}`+''
                      },
                      (results, status) => {
                        if (status == google.maps.GeocoderStatus.OK) {
                          let result;
                          if (results.length > 0) {
                            let result = results.length > 1 ? results[1] : results[0];
                            possolve(result);
                          } else {
                            possolve(null);
                          }
                        } else {
                          console.log('Geocode was not successful for the following reason: ' + status);
                          possolve(null);
                        }
                      }
                    );
                  });
                  if (pos !== null) {
                    this.activeItem.fullPath = [pos.geometry.location];
                  }
                }
            }
          }

          if (!this.activeItem.fullPath.length) return;

          let formattedArray = this.format(this.activeItem.fullPath);
          this.path.fullPolyline = L.polyline(formattedArray as [number, number][], { color: '#294f94' }).addTo(this.map);

          if (!this.viewModel.mapState) {
            this.map.flyTo(this.path.fullPolyline.getCenter());
            let length = this.activeItem.fullPath.length;
            if (length < 10) {
              console.log('length: ', length);
              this.map.setZoom(9);
              if (this.activeItem.fullPath.length > 0) {
                console.log('this.path.fullPolyline[0]: ', this.activeItem.fullPath[0]); 
                this.map.setView(this.activeItem.fullPath[0]);
              }
            } else {
              this.map.fitBounds(this.path.fullPolyline.getBounds());
            }

          } else {
            this.map.flyTo(this.viewModel.mapState.center);
            this.map.setZoom(this.viewModel.mapState.zoom);
          }

          if (this.activeItem.fullPath.length > 0) {
            let startingPosition;
            if (this.activeItem.fullPath[0]) {
              if (typeof this.activeItem.fullPath[0].lat == "function") {
                startingPosition = {
                  lat: this.activeItem.fullPath[0].lat(),
                  lng: this.activeItem.fullPath[0].lng()
                }
              } else {
                console.log('his.activeItem.fullPath[0]', this.activeItem.fullPath[0])
                startingPosition = {
                  lat: this.activeItem.fullPath[0].lat,
                  lng: this.activeItem.fullPath[0].lng
                }
              }
            }
            let startIcon = new L.Icon({
              iconUrl: await this.icons.transform(this.activeItem.cid + '', 'marker'),
              iconSize: [32, 32],
              iconAnchor: [16, 16],
            })
            this.path.marker.startMarker = new L.Marker([startingPosition.lat, startingPosition.lng], {
              icon: startIcon
            });
            this.path.marker.startMarker.addTo(this.map);

            if (this.activeItem.fullPath.length > 1) {
              let finishIcon = new L.Icon({
                iconUrl: this.icons.get('marker', 'finish'),
                iconSize: [32, 32],
                iconAnchor: [16, 16],
              })
              this.path.marker.endMarker = new L.Marker([this.activeItem.fullPath[this.activeItem.fullPath.length - 1].lat(), this.activeItem.fullPath[this.activeItem.fullPath.length - 1].lng()], {
                icon: finishIcon
              });
              this.path.marker.endMarker.addTo(this.map);
            }
          }
        }
        resolve(null);
      });
    });
  }
  initMapLeafletGoforest(resolve: any) {
    // DONE: leaflet
    this.clear();
    this.raceState = RaceState.countdown;
    this.platform.ready().then(() => {
      this.googleService.getGoogle().then(async google => {
        if (this.activeItem.routeData) {
          let data = JSON.parse(this.activeItem.routeData) as RouteInfos;
          if (data.routeInfos) {
              if (data.routeInfos.length > 0) {
                data.routeInfos.forEach(info => {
                  this.activeItem.fullPath = google.maps.geometry.encoding.decodePath(info.path);
                });
              } else {
                if (this.activeItem.lat !== null && this.activeItem.lng !== null) {
                // if (this.activeItem.event.lat !== null && this.activeItem.event.lng !== null) {
                  this.activeItem.fullPath = [new L.LatLng(this.activeItem.lat, this.activeItem.lng)];
                } else {
                  let pos = await new Promise<any>(possolve => {
                    let geocoder = new google.maps.Geocoder();

                    geocoder.geocode(
                      {
                        address: this.activeItem.event.plz + ' ' + this.activeItem.event.place
                      },
                      (results, status) => {
                        if (status == google.maps.GeocoderStatus.OK) {
                          let result;
                          if (results.length > 1) {
                            result = results[1];
                          } else {
                            result = results[0];
                          }
                          possolve(result);
                          //me.searchModel.zip = result.address_components[4].long_name;
                        } else {
                          possolve(null);
                        }
                      }
                    );
                  });
                  if (pos !== null) {
                    this.activeItem.fullPath = [pos.geometry.location];
                  }
                }
              }
          }

          console.log('this.activeItem.fullPath: ', this.activeItem.fullPath);
          let formattedArray = this.format(this.activeItem.fullPath);
          this.map.eachLayer(function (layer) {
            console.log('layer: ', layer);
          });
          this.path.fullPolyline = L.polyline(formattedArray as [number, number][], { color: '#294f94' }).addTo(this.map);
          console.log('line draw finished! ==========');
          if (!this.viewModel.mapState) {
            // let bounds = new google.maps.LatLngBounds();
            // this.activeItem.fullPath.forEach(item => {
            //   bounds.extend(item);
            // });
            //corrigate
            // let ne = bounds.getNorthEast();
            // let sw = bounds.getSouthWest();

            // let center = {
            //   lat: ne.lat() - (ne.lat() - sw.lat()) * (this.platform.height() / (this.platform.height() - 280) / 2),
            //   lng: ne.lng() - (ne.lng() - sw.lng()) / 2
            // };

            // let nb: {
            //   ne: { lat: number; lng: number };
            //   sw: { lat: number; lng: number };
            // } = {
            //   ne: {
            //     lat: ne.lat() + (ne.lat() - sw.lat()) * (this.platform.height() / (this.platform.height() - 280) / 4),
            //     lng: ne.lng()
            //   },
            //   sw: {
            //     lat: sw.lat(),
            //     lng: sw.lng()
            //   }
            // };
            // let zoom = this.getBoundsZoomLevel(nb);
            this.map.flyTo(this.path.fullPolyline.getCenter());
            this.map.fitBounds(this.path.fullPolyline.getBounds());
            // this.map.setCenter(center);
          } else {
            this.map.flyTo(this.viewModel.mapState.center);
            this.map.setZoom(this.viewModel.mapState.zoom);
          }

          if (this.activeItem.fullPath.length > 0) {
            let startingPosition = this.activeItem.fullPath[0];
            let startIcon = new L.Icon({
              iconUrl: await this.icons.transform(this.activeItem.cid + '', 'marker'),
              iconSize: [32, 32],
              iconAnchor: [16, 16],
            })
            this.path.marker.startMarker = new L.Marker([startingPosition.lat(), startingPosition.lng()], {
              icon: startIcon
            });
            this.path.marker.startMarker.addTo(this.map);

            if (this.activeItem.fullPath.length > 1) {
              let finishIcon = new L.Icon({
                iconUrl: this.icons.get('marker', 'finish'),
                iconSize: [32, 32],
                iconAnchor: [16, 16],
              })
              this.path.marker.endMarker = new L.Marker([this.activeItem.fullPath[this.activeItem.fullPath.length - 1].lat(), this.activeItem.fullPath[this.activeItem.fullPath.length - 1].lng()], {
                icon: finishIcon
              });
              this.path.marker.endMarker.addTo(this.map);
            }
          }
        }else{
          this.activeItem.routeData=null;
        }
        resolve(null);
      });
    });
  }
  format(_array) {
    let array = [];
    if (typeof _array[0].lat === "function") {
      for (let i = 0; i < _array.length; i++) {
        array.push([_array[i].lat(), _array[i].lng()]);
      }
      return array;
    } return _array;
  }


  getBoundsZoomLevel(bounds: { ne: { lat: number; lng: number }; sw: { lat: number; lng: number } }) {
    let WORLD_DIM = { height: 256, width: 256 };
    let ZOOM_MAX = 16;

    function latRad(lat) {
      let sin = Math.sin((lat * Math.PI) / 180);
      let radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
      return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
      return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }

    let ne = bounds.ne;
    let sw = bounds.sw;

    let latFraction = (latRad(ne.lat) - latRad(sw.lat)) / Math.PI;

    let lngDiff = ne.lng - sw.lng;
    let lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

    let latZoom = zoom(this.platform.height(), WORLD_DIM.height, latFraction);
    let lngZoom = zoom(this.platform.width(), WORLD_DIM.width, lngFraction);
    return Math.min(latZoom, lngZoom, ZOOM_MAX);
  }

  public isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  public profileImage(): string {
    return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
  }

  saveTile() {
    let doc = document.getElementsByClassName('savetiles')[1];
    console.log('doc: ', doc);
    // this.eventFire(doc, 'click');
  }

  eventFire(el, etype) {
    if (el.fireEvent) {
      el.fireEvent('on' + etype);
    } else {
      var evObj = document.createEvent('Events');
      evObj.initEvent(etype, true, false);
      el.dispatchEvent(evObj);
    }
  }
  saveTilesSub = null;
  loaded(map) {
    console.log('loaded()');
    if (this.isGoogleMap) {
      this.map = map;
    } else {
      console.log('loaded map this.isGoogleMap',this.isGoogleMap)

      if (map) {
        this.map.off();
        this.map.remove();
        this.map = null;
      }
      let lastPos = JSON.parse(localStorage.getItem('last-pos')) as any || { lat: 52.5204345, lng: 13.4014027 };

      this.map = (L as any).map('mapnearby', {
        center: [lastPos.lat, lastPos.lng],
        zoom: this.appDetector.isForestApp() ? 16 : 13,
        trackResize: false
      });
      this.baseLayer = (L as any).tileLayer
        .offline(this.urlTemplate, {
          attribution: 'Map data {attribution.OpenStreetMap}',
          subdomains: 'abc',
          minZoom: 1
        })
        .addTo(this.map);

        try{
          this.map.setView(
            lastPos,
            this.appDetector.isForestApp() ? 16 : 9
          );
        }catch (err){
          console.log('err in setview', JSON.stringify(err))
        }
      

      let that = this;
      let control = (L as any).control.savetiles(this.baseLayer, {
        zoomlevels: [16, 16], // optional zoomlevels to save, default current zoomlevel
        confirm(layer, successCallback) {
          console.log('layer: ', layer);
          successCallback();
        },
        confirmRemoval(layer, successCallback) {
          if (window.confirm('Remove all the tiles?')) {
            successCallback();
          }
        },
        saveText:
          '<i class="fa fa-download" aria-hidden="true" title="Save tiles"></i>',
        rmText: '<i class="fa fa-trash" aria-hidden="true"  title="Remove tiles"></i>',
      });
      control.addTo(this.map);

      let progress;
      this.baseLayer.on('savestart', (e) => {
        console.log('e: ', e);
        progress = 0;
        console.log(e._tilesforSave.length);
      });
      this.baseLayer.on('savetileend', () => {
        progress += 1;
        console.log("progress: " + progress);
      });
      if (!this.saveTilesSub) {
        console.log('in saveTilesSub()');
        this.saveTilesSub = timer(0, 10000).subscribe(() => {
          if (navigator.onLine) {
            this.saveTile();
            console.log('save tiles...')
          }
        });
      }
    }
    this.mapReady = true;
    this.map.on('dragend', () => {
      this.participantFocusEnabled = false;
    });
    let doc = document.getElementsByClassName('leaflet-top');
    if (doc) {
      for (let i = 0; i < doc.length; i++) {
        doc.item(i).setAttribute('style', "top: 12% !important");
        console.log('doc changed: ' + i);
      }
    }

    this.initMe();

    this.tryInit().then(() => {
      this.initMode();
      this.updateMap();
    })
  }

  // TODO CHECK
  initMe() {
    console.log('initMe()');
    this.googleService.getGoogle().then(google => {
      google.maps.event.addListener(this.map, 'dragend', () => {
        this.trackMyLocation = false;
      });
    });
  }

  meMarkerMove(pos: any) {
    console.log('[INFO] meMarkerMove()...');
    if (!this.play && !this.trackMyLocation) {
      console.log('return;')
      return;
    }
    this.isGoogleMap ? this.meMarkerMoveGoogle(pos) : this.meMarkerMoveLeaflet(pos);
    this.GPS_HIGH_ACCURACY = true;
  }

  meMarkerMoveGoogle(pos: any) {
    if (this.mapReady) {
      if (this.path.marker.meMarker) {
        let position = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
        this.path.marker.meMarker.setPosition(position);
      } else {
        let position = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
        this.path.marker.meMarker = new google.maps.Marker({
          map: this.map,
          icon: {
            url: this.icons.get('marker', 'me'),
            anchor: new google.maps.Point(16, 16),
            scaledSize: new google.maps.Size(32, 32)
          }
        });
        this.path.marker.meMarker.setPosition(position);
      }
      // if (this.trackMyLocation) {
      //   let position = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
      //   this.map.panTo(position);
      // }
    }
  }
  meMarkerMoveLeaflet(pos: any) {
    // DONE: leaflet
    console.log('meMarkerMoveLeaflet()');
    if (this.mapReady) {
      console.log('mapReady:meMarkerMoveLeaflet()');
      if (!this.path.marker.meMarker) {
        // let that = this;
        // this.map.eachLayer(function (layer) {
        //   if (layer instanceof L.Marker) {
        //     let layerIcon = layer.getIcon();
        //     console.log('layerIcon: ', layerIcon);
        //     if (layerIcon.options.iconUrl.includes("pulsing")) {
        //       layer.remove();
        //       if (that.path && that.path.marker && that.path.marker.meMarker) {
        //         delete that.path.marker.meMarker;
        //         that.path.marker.meMarker = null;
        //       }
        //       console.log('meMarker removed');
        //     }
        //   }
        // });
        let position = new L.LatLng(pos.coords.latitude, pos.coords.longitude);
        let meMarkerIcon = new L.Icon({
          iconUrl: this.icons.get('marker', 'me'),
          iconSize: [32, 32],
          iconAnchor: [16, 16],
        })
        this.path.marker.meMarker = new L.Marker(position, {
          icon: meMarkerIcon
        });
        this.path.marker.meMarker.addTo(this.map);
        console.log('marker added!');
      }

      let position = new L.LatLng(pos.coords.latitude, pos.coords.longitude);
      this.path.marker.meMarker.setLatLng(position);

      //Nearby screen has only spectator mode so no snapping appilied
      // if (this.trackMyLocation) {
      //   let position = new L.LatLng(pos.coords.latitude, pos.coords.longitude);
      //   this.map.flyTo(position);
      // }
    }
  }

  showLogin() {
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loader.present();
    if (this.detectorProvider.isHellaApp()) {
      this.sessionService.getToken(false, false).then(token => {
        loader.dismiss();
        this.app.getRootNav().push(IdRegistrationPage);
      });
    } else {
      let profile = this.sessionService.isLoged ? this.sessionService.profile : null;
      this.valueService.getProfileBackgrounds().then(backgrounds => {
        (this.app.getRootNav() as NavController)
          .push(MysportUserProfilePage, {
            data: { profile: profile, backgrounds: backgrounds }
          })
          .then(() => {
            loader.dismiss();
          });
      });
    }
  }

  showParticipantSearchPage() {
    this.sessionService.getLoginStatus().then(status => {
      if (status) this.spectate();
      else {
        new Promise((resolve, reject) => {
          if (this.detectorProvider.isHellaApp()) {
            this.sessionService.getToken(false, false).then(token => {
              this.app.getRootNav().push(IdRegistrationPage);
            });
          } else {
            this.app.getRootNav().push(LoginPage, { resolve: resolve })
          }
        }).then((status) => {
          if (status) this.spectate();
        });
      }
    });
  }

  register() {
    console.log('register: ');

    if (!this.detectorProvider.isHellaApp()) {
      this.showParticipate();
      return;
    }

    this.sessionService.getLogin().then(model => {
      this.eventService.getRoutesRegisteredByToken(model.email).then(routes => {
        if (routes) {
          let index = routes.indexOf(this.activeItem.event.id);
          if (index == -1) {
            new Promise<any>((resolve, reject) => {
              (this.app.getRootNav() as NavController).push(IdRegistrationPage, { resolve: resolve });
            }).then((status) => {
              if (status) {
                this.eventService.saveRegisteredRoute(model.email, this.activeItem.event.id);
                this.openStrackerPage();
              }
            });
          } else {
            this.openStrackerPage();
          }
        } else {
          new Promise<any>((resolve, reject) => {
            (this.app.getRootNav() as NavController).push(IdRegistrationPage, { resolve: resolve });
          }).then((status) => {
            this.sessionService.getLogin().then(model => {
              if (status) {
                this.eventService.saveRegisteredRoute(model.email, this.activeItem.event.id);
                this.openStrackerPage();
              }
            });
          });
        }
      });
    });
  }

  showParticipate() {
    this.sessionService.getLoginStatus().then(status => {
      // if (status) this.participate();
      if (status) this.openStrackerPage();
      else {
        new Promise((resolve, reject) => {
          if (this.detectorProvider.isHellaApp()) {
            this.sessionService.getToken(false, false).then(token => {
              this.app.getRootNav().push(IdRegistrationPage);
            });
          } else {
            this.app.getRootNav().push(LoginPage, { resolve: resolve })
          }
        }).then((status) => {
          if (status) this.participate();
        })
      }
    });
  }

  openStrackerPage() {
    this.sessionService.getToken(false, false).then(token => {
      this.strackerService.getResultPreload(this.activeItem.id, this.sessionService.profile.id + "").then(async (data: TrackerModel) => {
        GpsTracker.sumDistance = 0;
        GpsTracker.currentSpeed = "0";

        let option = {
          applause: false,
          autoPause: false,
          placement: false,
          google: false
        }

        await this.storageService.checkForExistance('autopause').then((status) => {
          if (status) this.storageService.getSaved('autopause').then((data) => option.autoPause = data);
        });

        await this.storageService.checkForExistance('applause').then((status) => {
          if (status) this.storageService.getSaved('applause').then((data) => option.applause = data);
        });

        await this.storageService.checkForExistance('placement').then((status) => {
          if (status) this.storageService.getSaved('placement').then((data) => option.placement = data);
        });

        await this.storageService.checkForExistance('google').then((status) => {
          if (status) this.storageService.getSaved('google').then((data) => option.google = data);
        });
        GlobalUtil.getInstance().currentEventID = this.nearbyEvents[this.dataSlider.getActiveIndex() || 0].id;
        this.eventService.registerForEvent(this.nearbyEvents[this.dataSlider.getActiveIndex() || 0].id).then((o) => {
          this.userService.getPrivateProfile().then((profile) => {

            // this.showParticipate();
            let reg: EventRegistrationModel= {
              eventId: this.nearbyEvents[0].id, 
              id: profile.id
            };
            this.strackerService.pushEventRegistration(reg).catch(err => console.log(err));
          if (o) {
            const m = this.modalCtrl.create(PopupRegistrationComponent, { event: this.nearbyEvents[0], registration: o });
            m.onDidDismiss((option) => {
              switch(option){
                case 0: (this.app.getRootNav() as NavController).push(StrackerPage, { event: this.nearbyEvents[this.dataSlider.getActiveIndex() || 0], imageLink: o.imageLink, data: data, token: token, route: { hasRoute: true, fullPath: this.nearbyEvents[this.dataSlider.getActiveIndex() || 0].fullPath }, option: option, eventId: this.activeItem.id });
              }
            });
            m.present();
          }
          else {
            this.toastCtrl.create({
              message: this.translate.instant('ERROR_IN_REGISTRATION'),
              duration: 3000
            }).present();
          }
          // (this.app.getRootNav() as NavController).push(StrackerPage, { event: this.nearbyEvents[this.dataSlider.getActiveIndex() || 0], imageLink: o.imageLink, data: data, token: token, route: { hasRoute: true, fullPath: this.nearbyEvents[this.dataSlider.getActiveIndex() || 0].fullPath }, option: option, eventId: this.activeItem.id });
        })
        });
      });
    });
  }


  participate() {
    this.activeItem.mode = 'participate';
    this.geoService.mode = TrackingMode.participant;
    this.userService.getPrivateProfile().then(profile => {
      this.toastCtrl.create({
        message: 'Zuschauer können Dich jetzt mit Deinem Profilnamen \'' + profile.forName + ' ' + profile.surName + '\' tracken',
        duration: 5000,
        position: 'top'
        // showCloseButton: true,
        // closeButtonText: 'Ok'
      }).present();
    })

    console.log('SCHEDULE = ' + this.SCHEDULE_GPS_CONTROL);

    if (this.SCHEDULE_GPS_CONTROL) {
      console.log('SCHEDULE_GPS_CONTROL: ' + this.SCHEDULE_GPS_CONTROL);
      return;
    }

    this.onPlayToogle();
    this.focusOnCurrentPosition();
  }

  reload() {
    this.reloadTrigger = false;
    setTimeout(() => {
      this.reloadTrigger = true
    });
  }

  // spectate() {
  //   this.activeItem.mode = 'spectate_share';
  //   this.startSendingPosition();
  //   (this.app.getRootNav() as NavController).push(NearbyEventParticipantSearchPage, { activeItem: this.activeItem });
  // }

  spectate() {
    this.alertCtrl
      .create({
        message: this.translate.instant('NEARBY_SHARE_POSITION_REQUEST_SPECTATOR'),
        buttons: [
          {
            text: this.translate.instant('GLOBAL_YES'),
            handler: () => {
              this.sessionService.getToken(false, false).then(() => {
                this.geoService.mode = TrackingMode.spectatorVisible;
                this.activeItem.mode = 'spectate_share';
                this.startSendingPosition();
                console.log('SCHEDULE_GPS_CONTROL: ' + this.SCHEDULE_GPS_CONTROL);

                if (this.SCHEDULE_GPS_CONTROL) return;

                this.onPlayToogle();
                this.focusOnCurrentPosition();
                (this.app.getRootNav() as NavController).push(NearbyEventParticipantSearchPage, { activeItem: this.activeItem, removeSub: this.removeSub });
              });
            }
          },
          {
            text: this.translate.instant('GLOBAL_NO'),
            handler: () => {
              this.geoService.mode = TrackingMode.spectatorInvisible;
              this.activeItem.mode = 'spectate_simple';
              console.log('SCHEDULE_GPS_CONTROL: ' + this.SCHEDULE_GPS_CONTROL);

              if (this.SCHEDULE_GPS_CONTROL) return;

              (this.app.getRootNav() as NavController).push(NearbyEventParticipantSearchPage, { activeItem: this.activeItem, removeSub: this.removeSub });
            }
          }
        ]
      })
      .present();
  }

  comingToParticipantListPage: boolean = false;
  showParticipantList() {
    this.comingToParticipantListPage = true;
    (this.app.getRootNav() as NavController).push(NearbyEventParticipantSearchPage, {
      activeItem: this.activeItem,
      removeSub: this.removeSub
    });
  }
}



class Ghost {
  fullDistanceKm: number;
  fullDistance: number;

  index: number = 0;
  aDist: number = 0;
  other: Ghost;
  position: any;
  isGoogleMap: boolean = false;

  constructor(public path, public google, public startDate: number, public total?: number) {
    this.update(path, startDate, total);
  }

  getPos(): Promise<any> {
    return new Promise((resolve, reject) => {
      let pos = null;
      if (this.path && this.path.length > 1 && this.total) {
        pos = this.calcPos(this.fullDistance * this.calcPrecent(), this.aDist, this.index);
        pos = new this.google.maps.LatLng(pos.lat, pos.lng);
      }

      resolve(pos);
    });
  }

  getWayToOther(): Promise<any> {
    return new Promise((resolve, reject) => {
      let polyline = [];
      if (this.other && this.path && this.path.length > 1 && this.total && this.other.total) {
        polyline = this.wayToOther();
      }
      resolve(polyline);
    });
  }

  update(path, startDate, total?) {
    this.index = 0;
    this.aDist = 0;
    this.path = path;
    this.startDate = startDate;
    this.total = total ? total * 1000 : total;
    this.fullDistance = 0;
    this.fullDistanceKm = 0;
    if (this.path && this.path.length > 0 && this.total) {
      this.fullDistanceKm = this.getDistanceInKm(this.path) / 1000;
      this.fullDistance = this.getDistance(this.path);
    }
  }

  getDistanceInKm(path) {
    let sum = 0;
    for (let i = 1; i < path.length; i++) {
      sum += this.google.maps.geometry.spherical.computeDistanceBetween(path[i - 1], path[i]);
    }
    return sum;
  }

  calcPrecent() {
    let prec = (new Date().getTime() - this.startDate) / this.total;
    return prec < 0 ? 0 : prec > 1 ? 1 : prec;
  }

  getDistance(path) {
    let sum = 0;
    for (let i = 1; i < path.length; i++) {
      sum += this.positionAbsDif(path[i - 1], path[i]);
    }
    return sum;
  }

  positionAbsDif(a, b) {
    return Math.abs(b.lat() - a.lat()) + Math.abs(b.lng() - a.lng());
  }

  positionMultipler(a, b, m) {
    let lat = a.lat() + (b.lat() - a.lat()) * m;
    let lng = a.lng() + (b.lng() - a.lng()) * m;
    return {
      lat: lat,
      lng: lng
    };
  }

  calcPos(tDist, aDist, index) {
    try {
      let oaDist = aDist + this.positionAbsDif(this.path[index], this.path[index + 1]);

      if (oaDist >= tDist) {
        let prec = (tDist - aDist) / this.positionAbsDif(this.path[index], this.path[index + 1]);
        this.index = index;
        this.aDist = aDist;
        this.position = this.positionMultipler(this.path[index], this.path[index + 1], prec);
        return this.position;
      } else {
        return this.calcPos(tDist, oaDist, index + 1);
      }
    } catch (e) {
      console.log(e, 'errooooooor');
    }
  }

  wayToOther() {
    let otherBigger = this.other.index > this.index;
    let maxIndex = otherBigger ? this.other.index : this.index;
    let maxPos = otherBigger ? this.other.position : this.position;
    let minIndex = !otherBigger ? this.other.index : this.index;
    let minPos = !otherBigger ? this.other.position : this.position;

    let ret = [];
    if (maxPos && minPos) {
      ret.push(minPos);
      maxIndex++;
      if (minIndex !== maxIndex) minIndex++;
      while (minIndex !== maxIndex) {
        if (this.path[minIndex]) ret.push(this.path[minIndex]);
        minIndex++;
      }
      ret.push(maxPos);
    }
    return ret;
  }
  getDistanceFromStartInKm() {
    return (this.calcPrecent() * this.fullDistanceKm).toFixed(2);
  }

  getDistanceBetween(posA, posB) {
    return (this.google.maps.geometry.spherical.computeDistanceBetween(posA, posB) / 1000).toFixed(2);
  }

}

enum RaceState {
  countdown = 0,
  started = 1,
  finished = 2
}




// WEBPACK FOOTER //
// /src/pages/nearby/main/nearby-main.ts